import React, { useEffect } from 'react'
import BrandBanner from './BrandBanner/BrandBanner'
import Logo from './Logo/Logo'
import Palette from './Palette/Palette'
import Typography from './Typography/Typography'
import Background from './Background/Background'
import { useTheme } from '../../contexts/ThemeProvider'
import Navbar from '../Homepage/Navbar/Navbar'
import Footer from '../Homepage/footer/Footer'
import SEO from '../SEO'

const BrandAssets = () => {
  const { theme, toggle } = useTheme();

  useEffect(() => {
    if (theme !== "dark") {
      toggle();
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <SEO
        url='https://www.rain.one/brand-assets'
      />
      <Navbar />
      <BrandBanner />
      <Logo />
      <Palette />
      {/* <Typography /> */}
      <Background />
      <Footer />
    </>
  )
}

export default BrandAssets